export const TestId = {
  // Auth
  LOGIN: {
    EMAIL_INPUT: "auth-email-input",
    PASSWORD_INPUT: "auth-password-input",
    SUBMIT_BUTTON: "auth-submit-button",
    ERROR_MESSAGE: "auth-error-message",
    USER_MENU: "auth-user-menu",
    LOGOUT_BUTTON: "auth-logout-button",
  },

  // Trucks
  TRUCK: {
    TABLE: "truck-table",
    ROW: "truck-row",
    DETAILS: "truck-details",
    NAME: "truck-name",
    STATUS: "truck-status",
    STATUS_FILTER: "truck-status-filter",
    STATUS_OPTION: (status: string) => `truck-status-option-${status}`,
    ADD_BUTTON: "truck-add-button",
    EDIT_BUTTON: "truck-edit-button",
    FORM: "truck-form",
  },

  // Truck History
  HISTORY: {
    TABLE: "history-table",
    ROW: "history-row",
    DETAILS: "history-details",
    EXPAND_BUTTON: "history-expand-button",
    DELETE_BUTTON: "history-delete-button",
    TAB: "history-tab",
  },

  // Common
  COMMON: {
    LOADING_SPINNER: "loading-spinner",
    CONFIRM_DIALOG: "confirm-dialog",
    CONFIRM_BUTTON: "confirm-button",
    QA_BANNER: "qa-environment-banner",
  },

  USERS: {
    ADD_BUTTON: "users-add-button",
    CREATE_FORM: "users-create-form",
    ROLE_SELECT: "users-role-select",
    EDIT_ROLE_FORM: "users-edit-role-form",
    EDIT_ROLE_SELECT: "users-edit-role-select",
    EDIT_ROLE_SUBMIT: "users-edit-role-submit",
    EDIT_ROLE_BUTTON: "users-edit-role-button",
    VIEW_PROFILE_BUTTON: "users-view-profile-button",
    TAB_STAFF: "users-tab-staff",
    TAB_DRIVERS: "users-tab-drivers",
  },

  COMPANY_SETTINGS: {
    DAILY_REPORT_LIMIT_INPUT: "company-settings-daily-report-limit",
    SAVE_BUTTON: "company-settings-save-button",
  },

  CUSTOMER: {
    TABLE: "customer-table",
    ROW: "customer-row",
    ADD_BUTTON: "customer-add-button",
    FORM: "customer-form",
  },

  OPS_TEAM: {
    TABLE: "ops-team-table",
    ROW: "ops-team-row",
    ADD_BUTTON: "ops-team-add-button",
    FORM: "ops-team-form",
    NAME: "ops-team-name",
    USER_IDS: "ops-team-user-ids",
    OUTSTANDING: "ops-team-outstanding",
  },

  ORDER: {
    KIND_TAB_TRIP: "order-kind-tab-trip",
    KIND_TAB_STANDBY: "order-kind-tab-standby",
    TABLE: "order-table",
    ROW: "order-row",
    ROW_READABLE_ID: (readableId: string) => `order-row-readable-id-${readableId}`,
    ADD_BUTTON: "order-add-button",
    ADD_MENU: "order-add-menu",
    CREATE_REPORT_BUTTON: "order-create-report-button",
    CREATE_REPORT_SUBMIT: "order-create-report-submit",
    CREATE_REPORT_CANCEL: "order-create-report-cancel",
    ROW_CHECKBOX: (orderId: string) => `order-row-checkbox-${orderId}`,
    STATUS_FILTER: "order-status-filter",
    TEAM_FILTER: "order-team-filter",
    OUTSTANDING: "order-outstanding",
    FORM: "order-form",
    DETAIL: "order-detail",
    READABLE_ID: "order-readable-id",
    CARD_HEADER: "order-card-header",
    CARD_EXTERNAL_ID: "order-card-external-id",
    STATUS: "order-status",
    TEAM: "order-team",
    NOTE: "order-note",
    DEPARTURE: "order-departure",
    DEPARTURE_DATE: "order-departure-date",
    DEPARTURE_TIME: "order-departure-time",
    TRUCK: "order-truck",
    DRIVER: "order-driver",
    CUSTOMER: "order-customer",
    ROUTE: "order-route",
    LOAD: "order-load",
    UNLOAD: "order-unload",
    PROOF: "order-proof",
    PROOF_INPUT: "order-proof-input",
    PROOF_OPEN: (attachmentId: string) => `order-proof-open-${attachmentId}`,
    PROOF_DOWNLOAD: (attachmentId: string) => `order-proof-download-${attachmentId}`,
    PROOF_VIEWER: "order-proof-viewer",
    PROOF_VIEWER_IMAGE: "order-proof-viewer-image",
    PROOF_VIEWER_CLOSE: "order-proof-viewer-close",
    PROOF_VIEWER_DOWNLOAD: "order-proof-viewer-download",
    PROOF_VIEWER_ZOOM_IN: "order-proof-viewer-zoom-in",
    PROOF_VIEWER_ZOOM_OUT: "order-proof-viewer-zoom-out",
    PROOF_VIEWER_ZOOM_RESET: "order-proof-viewer-zoom-reset",
    PROOF_REMOVE: (attachmentId: string) => `order-proof-remove-${attachmentId}`,
    EXTERNAL_ID: "order-external-id",
    EXPENSE_UANG_JALAN: "order-expense-uang-jalan",
    EXPENSE_MOB: "order-expense-mob",
    EXPENSE_MOB_ROUTE: "order-expense-mob-route",
    EXPENSE_TAKTIS: "order-expense-taktis",
    EXPENSE_REGISTRATION: "order-expense-registration",
    EXPENSE_ADDITIONAL_ROW: "order-expense-additional-row",
    EXPENSE_ADDITIONAL_AMOUNT: "order-expense-additional-amount",
    EXPENSE_ADDITIONAL_NOTES: "order-expense-additional-notes",
    EXPENSE_ADDITIONAL_ADD: "order-expense-additional-add",
    EXPENSE_ADDITIONAL_HEADER: "order-expense-additional-header",
    EXPENSE_SECTION: "order-expense-section",
    EXPENSE_ROW: (field: string) => `order-expense-row-${field}`,
    EXPENSE_TOTAL: "order-expense-total",
    EXPENSE_APPROVED_TOTAL: "order-expense-approved-total",
    OVERRIDE_NOTES: "order-override-notes",
    REVISION_NOTES: "order-revision-notes",
    SAVE: "order-save",
    CANCEL: "order-cancel",
    EDIT_BUTTON: "order-edit-button",
    HEADER_ACTIONS_MENU: "order-header-actions-menu",
    SUBMIT_REVIEW: "order-submit-review",
    REOPEN: "order-reopen",
    SUBMIT_REVISION: "order-submit-revision",
    SUBMIT_REVISION_DIALOG: "order-submit-revision-dialog",
    SUBMIT_REVISION_DIALOG_SUBMIT: "order-submit-revision-dialog-submit",
    REQUEST_REVISION: "order-request-revision",
    VERIFY: "order-verify",
    DELETE: "order-delete",
    REVISION_NOTE: "order-revision-note",
    VIEW_REPORT: "order-view-report",
    EXPENSE_CHECKLIST: "order-expense-checklist",
    TOTAL_PAID: "order-total-paid",
    TOTAL_APPROVED: "order-total-approved",
    /** @deprecated Use TOTAL_APPROVED */
    TOTAL_VERIFIED: "order-total-approved",
    DIFFERENCE: "order-difference",
    HISTORY: "order-history",
    HISTORY_ENTRY: "order-history-entry",
    HISTORY_SUMMARY: "order-history-summary",
    HISTORY_CHANGE: "order-history-change",
  },

  STANDBY: {
    TABLE: "standby-table",
    ROW: "standby-row",
    ROW_READABLE_ID: (readableId: string) => `standby-row-readable-id-${readableId}`,
    ROW_CHECKBOX: (orderId: string) => `standby-row-checkbox-${orderId}`,
    ADD_BUTTON: "standby-add-button",
    STATUS_FILTER: "standby-status-filter",
    TEAM_FILTER: "standby-team-filter",
    FORM: "standby-form",
    DETAIL: "standby-detail",
    READABLE_ID: "standby-readable-id",
    CARD_HEADER: "standby-card-header",
    STATUS: "standby-status",
    TEAM: "standby-team",
    NOTE: "standby-note",
    DATE: "standby-date",
    DRIVER: "standby-driver",
    TRUCK: "standby-truck",
    LOCATION: "standby-location",
    AMOUNT: "standby-amount",
    EXPENSE_ADDITIONAL_ROW: "standby-expense-additional-row",
    EXPENSE_ADDITIONAL_AMOUNT: "standby-expense-additional-amount",
    EXPENSE_ADDITIONAL_NOTES: "standby-expense-additional-notes",
    EXPENSE_ADDITIONAL_ADD: "standby-expense-additional-add",
    EXPENSE_ADDITIONAL_HEADER: "standby-expense-additional-header",
    SAVE: "standby-save",
    CANCEL: "standby-cancel",
    EDIT_BUTTON: "standby-edit-button",
    HEADER_ACTIONS_MENU: "standby-header-actions-menu",
    SUBMIT_REVIEW: "standby-submit-review",
    REOPEN: "standby-reopen",
    SUBMIT_REVISION: "standby-submit-revision",
    DELETE: "standby-delete",
    VIEW_REPORT: "standby-view-report",
    EXPENSE_CHECKLIST: "standby-expense-checklist",
    TOTAL_PAID: "standby-total-paid",
    TOTAL_APPROVED: "standby-total-approved",
    DIFFERENCE: "standby-difference",
    REVISION_NOTES: "standby-revision-notes",
  },

  UJR: {
    TABLE: "ujr-table",
    ROW: "ujr-row",
    ROW_READABLE_ID: (readableId: string) => `ujr-row-readable-id-${readableId}`,
    ADD_BUTTON: "ujr-add-button",
    CREATE_FORM: "ujr-create-form",
    TEAM: "ujr-team",
    STATUS_FILTER: "ujr-status-filter",
    TEAM_FILTER: "ujr-team-filter",
    ORDER_CHECKBOX: (orderId: string) => `ujr-order-checkbox-${orderId}`,
    SUBMIT: "ujr-submit",
    DETAIL: "ujr-detail",
    READABLE_ID: "ujr-readable-id",
    STATUS: "ujr-status",
    HEADER_ACTIONS_MENU: "ujr-header-actions-menu",
    TOTAL_PAID: "ujr-total-paid",
    TOTAL_APPROVED: "ujr-total-approved",
    DIFFERENCE: "ujr-difference",
    ORDER_ROW: "ujr-order-row",
    ORDER_TOTALS: (orderId: string) => `ujr-order-totals-${orderId}`,
    CHECKLIST: "ujr-checklist",
    CHECKLIST_REGULAR: "ujr-checklist-regular",
    CHECKLIST_ADDITIONAL: "ujr-checklist-additional",
    CHECKLIST_ITEM: (orderId: string, itemKey: string) => `ujr-checklist-${orderId}-${itemKey}`,
    VERIFY_ORDER: (orderId: string) => `ujr-verify-order-${orderId}`,
    REVISE_ORDER: (orderId: string) => `ujr-revise-order-${orderId}`,
    ORDER_CARD_ACTIONS_MENU: (orderId: string) => `ujr-order-card-actions-menu-${orderId}`,
    APPROVE_ORDER: (orderId: string) => `ujr-approve-order-${orderId}`,
    APPROVE_OVERRIDE_ORDER: (orderId: string) => `ujr-approve-override-order-${orderId}`,
    APPROVE_OVERRIDE_DIALOG: "ujr-approve-override-dialog",
    APPROVE_OVERRIDE_LINE: (lineKey: string) => `ujr-approve-override-${lineKey}`,
    APPROVE_OVERRIDE_UANG_JALAN: "ujr-approve-override-uang_jalan",
    APPROVE_OVERRIDE_MOB: "ujr-approve-override-mob",
    APPROVE_OVERRIDE_TAKTIS: "ujr-approve-override-taktis",
    APPROVE_OVERRIDE_REGISTRATION: "ujr-approve-override-registration",
    APPROVE_OVERRIDE_ADDITIONAL: "ujr-approve-override-additional",
    APPROVE_OVERRIDE_NOTES: "ujr-approve-override-notes",
    APPROVE_OVERRIDE_SUBMIT: "ujr-approve-override-submit",
    VERIFY_REPORT: "ujr-verify-report",
    REQUEST_REVISION_REPORT: "ujr-request-revision-report",
    REQUEST_REVISION_REPORT_BUTTON: "ujr-request-revision-report-button",
    REQUEST_REVISION_DIALOG: "ujr-request-revision-dialog",
    REQUEST_REVISION_ORDER_SELECT: "ujr-request-revision-order-select",
    REQUEST_REVISION_NOTE: "ujr-request-revision-note",
    APPROVE_REPORT: "ujr-approve-report",
    DOWNLOAD_EXCEL: "ujr-download-excel",
    STATUS_HISTORY: "ujr-status-history",
    HISTORY_ENTRY: "ujr-history-entry",
    HISTORY_SUMMARY: "ujr-history-summary",
    REVISION_NOTE: "ujr-revision-note",
    SUBMIT_FOR_REVIEW: "ujr-submit-for-review",
    STANDBY_SECTION: "ujr-standby-section",
    STANDBY_ROW: "ujr-standby-row",
    STANDBY_CHECKBOX: (orderId: string) => `ujr-standby-checkbox-${orderId}`,
    ADD_STANDBY: "ujr-add-standby",
    ADD_STANDBY_DIALOG: "ujr-add-standby-dialog",
    ADD_STANDBY_SUBMIT: "ujr-add-standby-submit",
    ADD_STANDBY_CHECKBOX: (orderId: string) => `ujr-add-standby-checkbox-${orderId}`,
    VERIFY_STANDBY: (orderId: string) => `ujr-verify-standby-${orderId}`,
    REVISE_STANDBY: (orderId: string) => `ujr-revise-standby-${orderId}`,
    STANDBY_CARD_ACTIONS_MENU: (orderId: string) => `ujr-standby-card-actions-menu-${orderId}`,
    APPROVE_STANDBY: (orderId: string) => `ujr-approve-standby-${orderId}`,
    APPROVE_OVERRIDE_STANDBY: (orderId: string) => `ujr-approve-override-standby-${orderId}`,
    ADD_ORDERS: "ujr-add-orders",
    ADD_ORDERS_DIALOG: "ujr-add-orders-dialog",
    ADD_ORDERS_SUBMIT: "ujr-add-orders-submit",
    ADD_ORDER_CHECKBOX: (orderId: string) => `ujr-add-order-checkbox-${orderId}`,
    VIEW_ORDER: (orderId: string) => `ujr-view-order-${orderId}`,
    REVISION_DIALOG: "ujr-revision-dialog",
    REVISION_SUBMIT: "ujr-revision-submit",
    ORDER_TOTAL_PAID: (orderId: string) => `ujr-order-total-paid-${orderId}`,
    ORDER_TOTAL_APPROVED: (orderId: string) => `ujr-order-total-approved-${orderId}`,
    /** @deprecated Use ORDER_TOTAL_APPROVED */
    ORDER_TOTAL_VERIFIED: (orderId: string) => `ujr-order-total-approved-${orderId}`,
  },

  DASHBOARD: {
    PAGE: "dashboard-page",
    PERIOD: "dashboard-period",
    PERIOD_OPTION: (preset: string) => `dashboard-period-${preset}`,
    TEAM_FILTER: "dashboard-team-filter",
    CUSTOM_FROM: "dashboard-custom-from",
    CUSTOM_TO: "dashboard-custom-to",
    APPLY_CUSTOM: "dashboard-apply-custom",
    KPI_ORDERS: "dashboard-kpi-orders",
    KPI_STANDBY: "dashboard-kpi-standby",
    KPI_REPORTS: "dashboard-kpi-reports",
    TOTAL_PAID: "dashboard-total-paid",
    TOTAL_APPROVED: "dashboard-total-approved",
    DIFFERENCE: "dashboard-difference",
    ATTENTION: "dashboard-attention",
    ATTENTION_ORDERS: "dashboard-attention-orders",
    ATTENTION_STANDBY: "dashboard-attention-standby",
    ATTENTION_REPORTS: "dashboard-attention-reports",
    ATTENTION_SURAT_JALAN: "dashboard-attention-surat-jalan",
    DAILY_TABLE: "dashboard-daily-table",
    EXPENSE_MIX: "dashboard-expense-mix",
    WORKFLOW: "dashboard-workflow",
    TEAM_TABLE: "dashboard-team-table",
    TEAM_ROW: (id: string) => `dashboard-team-row-${id}`,
  },

  SIDEBAR: {
    ROOT: "sidebar",
    TOGGLE: "sidebar-toggle",
    MENU_ITEM_TRUCKS: "sidebar-menu-item-trucks",
    MENU_ITEM_USERS: "sidebar-menu-item-users",
    MENU_ITEM_COMPANY_SETTINGS: "sidebar-menu-item-company-settings",
    MENU_ITEM_OPS_TEAMS: "sidebar-menu-item-operations-teams",
    MENU_ITEM_LOCATIONS: "sidebar-menu-item-locations",
    MENU_ITEM_VENDORS: "sidebar-menu-item-vendors",
    MENU_ITEM_CUSTOMERS: "sidebar-menu-item-customers",
    MENU_ITEM_TUTORIAL: "sidebar-menu-item-tutorial",
    MENU_ITEM_STATIC_VALUES: "sidebar-menu-item-static-values",
    PROFILE: "sidebar-profile",
    PROFILE_NAME: "sidebar-profile-name",
    LANGUAGE_SELECT: "sidebar-language-select",
    LANGUAGE_OPTION_EN: "sidebar-language-option-en",
    LANGUAGE_OPTION_ID: "sidebar-language-option-id",
    THEME_SELECT: "sidebar-theme-select",
    THEME_OPTION_LIGHT: "sidebar-theme-option-light",
    THEME_OPTION_DARK: "sidebar-theme-option-dark",
    DENSITY_SELECT: "sidebar-density-select",
    TRUCK_GROUPS_MENU: "sidebar-truck-groups-menu",
    STATIC_VALUES_MENU: "sidebar-static-values-menu",
    TRUCK_TYPE_WINGBOX: "sidebar-truck-type-wingbox",
    TRUCK_TYPE_LOSBAK: "sidebar-truck-type-losbak",
    TRUCK_TYPE_DUMP: "sidebar-truck-type-dump",
    TRUCK_GROUP: "sidebar-truck-group",
    MENU_ITEM_DEV_TOOLS: "sidebar-menu-item-dev-tools",
    MENU_ITEM_DATA_IMPORTER: "sidebar-menu-item-data-importer",
    MENU_ITEM_DEDUPE_USERS: "sidebar-menu-item-dedupe-users",
    MENU_ITEM_LOGISLY_SPX_ONCALL: "sidebar-menu-item-logisly-spx-oncall",
    MENU_ITEM_UANG_JALAN: "sidebar-menu-item-uang-jalan",
    MENU_ITEM_DASHBOARD: "sidebar-menu-item-dashboard",
    MENU_ITEM_ORDERS: "sidebar-menu-item-orders",
    MENU_ITEM_ORDERS_ACTION_REQUIRED: "sidebar-menu-item-orders-action-required",
    MENU_ITEM_ORDERS_ALL: "sidebar-menu-item-orders-all",
    MENU_ITEM_UJR_ACTION_REQUIRED: "sidebar-menu-item-ujr-action-required",
    MENU_ITEM_UJR_ALL: "sidebar-menu-item-ujr-all",
    MENU_ITEM_SURAT_JALAN: "sidebar-menu-item-surat-jalan",
    MENU_ITEM_SJ_ACTION_REQUIRED: "sidebar-menu-item-sj-action-required",
    MENU_ITEM_SJ_ALL: "sidebar-menu-item-sj-all",
    SURAT_JALAN_MENU: "sidebar-surat-jalan-menu",
    ORDERS_MENU: "sidebar-orders-menu",
    UANG_JALAN_MENU: "sidebar-uang-jalan-menu",
    DEV_TOOLS_MENU: "sidebar-dev-tools-menu",
  },

  SURAT_JALAN: {
    LIST: "surat-jalan-list",
    TABLE: "surat-jalan-table",
    STATUS_FILTER: "surat-jalan-status-filter",
    TEAM_FILTER: "surat-jalan-team-filter",
    DETAIL: "surat-jalan-detail",
    READABLE_ID: "surat-jalan-readable-id",
    STATUS: "surat-jalan-status",
    VERIFY: "surat-jalan-verify",
    APPROVE: "surat-jalan-approve",
    REQUEST_REVISION: "surat-jalan-request-revision",
    REVISION_DIALOG: "surat-jalan-revision-dialog",
    REVISION_NOTE: "surat-jalan-revision-note",
    REVISION_SUBMIT: "surat-jalan-revision-submit",
    ORDER_LINK: "surat-jalan-order-link",
    REPORT_LINK: "surat-jalan-report-link",
    ACTIONS_MENU: "surat-jalan-actions-menu",
    ROW_VERIFY: (id: string) => `surat-jalan-row-verify-${id}`,
    ROW_APPROVE: (id: string) => `surat-jalan-row-approve-${id}`,
    ROW_REQUEST_REVISION: (id: string) => `surat-jalan-row-request-revision-${id}`,
    HISTORY: "surat-jalan-history",
    HISTORY_ENTRY: "surat-jalan-history-entry",
    HISTORY_SUMMARY: "surat-jalan-history-summary",
    HISTORY_CHANGE: "surat-jalan-history-change",
  },

  ORDER_SURAT_JALAN: {
    LINK: "order-surat-jalan-link",
  },

  PROFILE: {
    DENSITY_SECTION: "profile-density-section",
    DENSITY_DESKTOP_SELECT: "profile-density-desktop-select",
    DENSITY_MOBILE_SELECT: "profile-density-mobile-select",
    DENSITY_SAVE_BUTTON: "profile-density-save-button",
  },
} as const;
